import { ChangeEvent, FormEvent, useEffect, useState } from 'react';
import { useOperator } from '../contexts/OperatorContext';
import { getEventValueAsType } from '../lib/formatters';

type Form = {
  [name: string]: {
    isValid?: boolean;
    validate?: (value: any) => boolean;
    value: any;
  };
};

export function useFormValidation(initialState: Form, callback: () => void) {
  const [values, setValues] = useState(initialState);
  const operator = useOperator();

  useEffect(() => {
    setValues(initialState);
  }, [operator.id]);

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    const field = values[event.target.name];
    if (!field) return;

    const value = getEventValueAsType(event);
    const isValid = field.validate ? field.validate(value) : true;

    setValues(
      Object.assign({}, values, {
        [event.target.name]: {
          ...field,
          isValid: isValid,
          value: value,
        },
      })
    );
  };

  const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    event.stopPropagation();

    await callback();
  };

  const resetForm = () => {
    setValues(initialState);
  };

  return {
    onChange,
    onSubmit,
    values,
    resetForm,
  };
}
